import { z } from 'zod';

export const FontMetadataSchema = z.object({
  category: z.string(),
  family: z.string(),
  files: z.record(z.string(), z.string()),
  variants: z.array(z.string()),
});

export type FontMetadata = z.infer<typeof FontMetadataSchema>;
